import { searchParamKeys } from '../../../shared/configs/searchParams';
import { useSearchParamsSelector } from '../../../shared/packages/searchParamsManager';
import {
  parsedAcceptanceSlugsIsEqual,
  parseAcceptanceSlug,
} from '../../../shared/packages/acceptance';

export const useParsedAcceptanceSlug = () =>
  useSearchParamsSelector((state) => {
    return parseAcceptanceSlug(state[searchParamKeys.acceptance]);
  }, parsedAcceptanceSlugsIsEqual);
